import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from '../../factory/createErrorEvent'
import {NotificationActionTypes, successNotify,} from '../../factory/createNotification'
import {bindQueryParam} from '../../functions/routerHelper'
import {
    church_createChurchMassTime_Api,
    church_deleteChurchMassTime_Api,
    church_updateChurchMassTime_Api
} from "../../../../apis";

export const useChurchMassTimes = ({
                                       church_id,
                                       notifyListeners = {
                                           onCreated: undefined,
                                           onUpdated: undefined,
                                           onDeleted: undefined,
                                       },
                                   }) => {
    const t = useTranslate()

    const {
        onCreated = NullAsDefault,
        onUpdated = NullAsDefault,
        onDeleted = NullAsDefault,
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: onCreate, ...asyncCreating} = useAsyncAction({
        onError,
        query: bindQueryParam({church_id}),
        apiInfo: church_createChurchMassTime_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onCreated(result, data)
        },
    })

    const {handleAsyncAction: onUpdate, ...asyncUpdating} = useAsyncAction({
        onError,
        apiInfo: church_updateChurchMassTime_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onUpdated(result, data)
        },
    })

    const {handleAsyncAction: onDelete, ...asyncDeleting} = useAsyncAction({
        onError,
        apiInfo: church_deleteChurchMassTime_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onDeleted(result, data)
        },
    })

    return {
        onCreate,
        onUpdate,
        onDelete,
        asyncCreating,
        asyncUpdating,
        asyncDeleting,
    }
}


